import React, { Component } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { CheckUser, getGeoInfo, userprofile } from "../../Model/Users";
import { applyCoupons } from "../../Model/Payment";
import Makepayment from "../Makepayment/Makepayment";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { Metadata } from "../Metadata/Metadata";
import BarLoader from "react-spinners/BarLoader";
import {
  withRouter,
  SVGIcons,
  ImgIcons,
  Appsflyer,
  branchIO,
  VirsionCheck,
} from "../../Helpers/Common";
import { CurrencyData } from "./Currency_json";
import { motion } from "framer-motion";
import { SubscriptionPlans } from "../../Model/Subscription";
import "./ExplorePlan.css";
import { isMobile } from "react-device-detect";
import { ToastContainer, toast } from "react-toastify";

var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

function updateDiscountMethod(plandetails) {
  if (plandetails) {
    for (let i = 0; i < plandetails.length; i++) {
      const plan = plandetails[i];
      if (plan.actual_price === plan.discounted_price) {
        switch (plan.name) {
          case "Yearly":
            var yearlyPlans = document.getElementsByClassName("yearly_hidden_plan");
            if (yearlyPlans.length > 0) {
              yearlyPlans[0].style.display = "none";
            }
            break;
          case "Quarterly":
            var quarterlyPlans = document.getElementsByClassName("quarterly_hidden_plan");

            if (quarterlyPlans.length > 0) {
              quarterlyPlans[0].style.display = "none";
            }
            break;
          case "Monthly":
            var monthlyPlans = document.getElementsByClassName("monthly_hidden_plan");
            if (monthlyPlans.length > 0) {
              monthlyPlans[0].style.display = "none";
            }
            break;
          default:
            break;
        }
      }
    }
  }
}

class ExplorePlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SubscriptionPlansloaded: false,
      SubscriptionPlansData: false,
      showModal: false,
      couponcode: false,
      couponcodeerr: false,
      cplans: false,
      showmakepayment: false,
      Resapplycouponmsg: false,
      country: "",
      disableButton: false,
      goldenDIcon: "",
      silverDIcon: "",
      showPopup: false,
      showconfirm: false,
      popHolder: true,
      value: ''
    };

  }
  makepayment(actualplan, discount) {
    // Appsflyer("purchase_" + actualplan.name + "_web", {
    //   "Plan Amount": actualplan.actual_price,
    // });
    // branchIO("purchase_" + actualplan.name + "_web", {
    //   "Plan Amount": actualplan.actual_price,
    // })

    this.setState({
      showmakepayment: true,
      actualplan: actualplan,
      discount: discount,
    });
  }

  applyCouponsaction() {
    var postdata = {
      "couponcode": this.state.value,
      "country": this.state.country
    }
    Appsflyer("PromoCode Initiated", {});
    applyCoupons(postdata).then((res) => {
      var Resapplycoupon = JSON.parse(res.data);
      if (Resapplycoupon.errorcode == 1008) {
        this.props.navigate("/createaccount");
      } else if (Resapplycoupon.errorcode == 1084) {
        Appsflyer("PromoCode Failed", {});
        this.setState({
          couponcodeerr: Resapplycoupon.message,
          Resapplycouponmsg: false,
        });
      } else if (Resapplycoupon.errorcode == 1164) {
        Appsflyer("PromoCode Failed", {});
        this.setState({
          couponcodeerr: Resapplycoupon.message,
          Resapplycouponmsg: false,
        });
      } else if (Resapplycoupon.errorcode == 1007) {
        Appsflyer("PromoCode Failed", {});
        this.setState({
          couponcodeerr: Resapplycoupon.message,
          Resapplycouponmsg: false,
        });
      } else if (Resapplycoupon.errorcode == 1058) {
        Appsflyer("PromoCode Failed", {});
        this.setState({
          couponcodeerr: Resapplycoupon.message,
          Resapplycouponmsg: false,
        });
      } else if (Resapplycoupon.errorcode == 1060) {
        Appsflyer("Coupon code expired", {});
        this.setState({ couponcodeerr: Resapplycoupon.message, Resapplycouponmsg: false })
      } else {
        Appsflyer("PromoCode Applied", {});
        // this.setState({
        //   SubscriptionPlansloaded: true,
        //   cplans: Resapplycoupon.plans,
        //   Resapplycouponmsg : true,
        //   couponcodeerr:false
        // });
        //this.setState({showModal:true,})
        if (Resapplycoupon.message == "Subscription created successfully!") {
          this.setState({ subscription_success: true });
        } else {
          this.setState({
            SubscriptionPlansloaded: true,
            cplans: Resapplycoupon.plans,
            Resapplycouponmsg: true,
            couponcodeerr: false,
            disableButton: true,
          });
          //this.setState({showModal:true,})
        }
      }
    });
  }

  handleChange(e) {
    this.setState({ couponcode: e.target.value, disableButton: false, value: e.target.value });
  }

  Closemodal() {
    this.setState({ showModal: false });
  }

  backbtn() {
    this.setState({ showmakepayment: false });
  }

  componentDidMount() {
    VirsionCheck().then((vcheckres) => {
      if (vcheckres.data) {
        this.setState({
          goldenDIcon: JSON.parse(vcheckres.data).data["golden-dweb"],
          silverDIcon: JSON.parse(vcheckres.data).data["silver-dweb"],
        });
      }
    });
    let data = {
      seesionID: localStorage.getItem("session_id"),
      userID: localStorage.getItem("userID")
    }
    userprofile(data).then((userDatares) => {
      if (JSON.parse(userDatares.data.message).success == false) {
        this.props.navigate("/createaccount");
      }

      if (userDatares.data.message == "session_expired") {
        //Redirect To login page.
        this.props.navigate("/createaccount");
      }
    });
    //Get Get User checked Check Data
    getGeoInfo().then((res) => {
      this.setState({
        country: res,
      });
    });
    Appsflyer("membership_screen_visited", {});
    CheckUser().then((checkuserstatus) => {
      if (checkuserstatus == null) {
        this.props.navigate("/createaccount");
      } else {
        SubscriptionPlans().then((SubscriptionData) => {
          this.setState({
            SubscriptionPlansloaded: true,
            SubscriptionPlansData: SubscriptionData,
            plans: SubscriptionData.data.plans,
          });
        });
      }
    });
  }

  componentDidUpdate() {
    updateDiscountMethod(this.state.cplans);
  }

  showPopUp() {
    this.setState({
      showPopup: true
    })
  }

  cancel() {
    this.setState({ popHolder: false });
  }

  async copyContent() {
    const copiedText = 'DB99';
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(copiedText);
        this.setState({ value: copiedText });
      } catch (err) {
        // console.error('Failed to copy: ', err);
      }
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = copiedText;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.setState({ value: copiedText });
        toast("Code Copied!", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: false,
          draggable: true,
          theme: "light",
          className: "toast-message-text",
        });
      } catch (err) {
        // console.error('Failed to copy: ', err);
      } finally {
        document.body.removeChild(textArea);
      }
    }
  }

  render() {

    if (this.state.SubscriptionPlansloaded == false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    } else if (this.state.showmakepayment == true) {
      return <Makepayment props={this} />;
    } else {
      const settings = {
        centerMode: true,
        variableWidth: false,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 2,
              infinite: true,
              variableWidth: false,
              dots: true,
              cssEase: "linear",
              centerPadding: "70px",
            },
          },
          {
            breakpoint: 820,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 2,
              infinite: true,
              variableWidth: false,
              cssEase: "linear",
              centerPadding: "70px",
              dots: true,
            },
          },
          {
            breakpoint: 650,
            settings: {
              slidesToShow: 1,
              infinite: true,
              variableWidth: false,
              dots: true,
              arrows: false,
              cssEase: "linear",
              centerPadding: "70px",
              centerMode: true,
            },
          },
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 1,
              infinite: true,
              variableWidth: false,
              dots: true,
              arrows: false,
              cssEase: "linear",
              centerPadding: "55px",
              centerMode: true,
            },
          },
          {
            breakpoint: 416,
            settings: {
              slidesToShow: 1,
              infinite: true,
              variableWidth: false,
              dots: true,
              arrows: false,
              cssEase: "linear",
              centerPadding: "45px",
              centerMode: true,
            },
          },
          {
            breakpoint: 379,
            settings: {
              slidesToShow: 1,
              infinite: true,
              variableWidth: false,
              dots: true,
              arrows: false,
              cssEase: "linear",
              centerPadding: "35px",
              centerMode: true,
            },
          },
          {
            breakpoint: 359,
            settings: {
              slidesToShow: 1,
              infinite: true,
              variableWidth: false,
              dots: true,
              arrows: false,
              cssEase: "linear",
              centerPadding: "30px",
              centerMode: true,
            },
          },
        ],
      };
      return (
        <>
          <Metadata page="BECOME-MEMBER" />
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2 }}
          >
            <div className="temp4 dD-none">
              <hr className="border-red" />
              <hr />
              <div className="temp4-InnerRound50">
                <div className="temp4-InnerRound1">
                  <div className="temp4-InnerRound2" />
                </div>
              </div>
              <div className="temp4-InnerRound51">
                <div className="temp4-InnerRound1">
                  <div className="temp4-InnerRound2" />
                </div>
              </div>
              <div className="temp4-InnerRound52">
                <div className="temp4-InnerRound3" />
              </div>
            </div>

            <header>
              <div className="mainNav dD-none">
                {/* <div className="docubayBack white pl-8">{this.props.title}</div> */}
                <div className="docubayBack white pl-8">Become A Member</div>
                <div className="topQuestion">
                  {/*<img src={SVGIcon["help.svg"]} alt="help" />*/}
                </div>
              </div>
            </header>

            <main className="dD-none" >
              {this.state.country == "IN" ?
                localStorage.getItem("utmTrack") ? (this.state.popHolder ?
                  <>
                    <div className="logOutpopup" id="logOut">
                      <div className="temp52-modal-body-img" style={{ background: "none" }}>
                        <img
                          src={ImageData["close-grey.png"]}
                          alt="closeImg"
                          className="close-modal-icon1"
                          onClick={() => {
                            this.cancel();
                          }}
                        />
                        <img
                          src={"https://dbcms.docubay.com/media-upload/1711464631-popup-280x345.jpg"}
                          alt="Discount"
                          style={{ borderRadius: "12px", cursor: 'pointer' }}
                          onClick={() => { this.copyContent() }}
                        />
                        <ToastContainer />
                      </div>
                    </div>
                  </>
                  : null)
                  : null
                : null
              }

              <div className="explore-bg-img"></div>
              <div className="explore-section"></div>

              <section className="mb-32">
                <div className="temp7">
                  <div className="temp7-inner">
                    <div className="temp7-head">
                      <h5>Choose a plan</h5>
                      {/* {this.state.SubscriptionPlansData.data.banner_data !=
                        null ? (
                        <img
                          src={
                            this.state.SubscriptionPlansData.data.banner_data
                              .banner
                          }
                          alt="DocuBay"
                        />
                      ) : null} */}
                      {this.state.country == "IN" ?
                        <img
                          src={
                            this.state.SubscriptionPlansData.data.banner_data
                              .banner
                          }
                          alt="DocuBay"
                        /> :
                        <img
                          src={"https://dbcms.docubay.com/media-upload/1647267810-app-banner2-1024x280.jpg"}
                          alt="DocuBay"
                        />
                      }
                    </div>
                    <div className="temp7-sliderArea">
                      <div className="temp7-slider">
                        <Slider {...settings}>
                          {this.state.SubscriptionPlansData.data.plans.map(
                            (PlansData, i) => {
                              var currencyData = CurrencyData();
                              var Pricecurr = PlansData.currency;
                              var currency = currencyData[Pricecurr];
                              if (Pricecurr == "U") {
                              }
                              if (PlansData.name == "Yearly") {
                                return (
                                  <div
                                    className="temp7-sliderItem order-1"
                                    key={PlansData.name}
                                  >
                                    <div className="temp7-item">
                                      <img
                                        src={ImageData["onetribe-member1.png"]}
                                        alt=""
                                        className="w-100 imgbackground"
                                        Unlimited
                                        documentaries
                                      />
                                      <div className="temp7-txt">
                                        <div className="temp7-txt-Head">
                                          <div className="temp7-txt-Headleft">
                                            <div className="temp7-txt-Headleft1 white2">
                                              <img
                                                src={
                                                  this.state.silverDIcon
                                                }
                                              />
                                              {/* <img
                                                src={
                                                  ImageData[
                                                    "membership-btn.png"
                                                  ]
                                                }
                                              /> */}
                                              <span>
                                                {" "}
                                                {PlansData.title.head}{" "}
                                              </span>
                                              {PlansData.title.title}
                                            </div>
                                            <p className="white">
                                              {PlansData.in_month_validity}{" "}
                                              Months access
                                            </p>
                                          </div>
                                          <div className="temp7-txt-Headright white2">
                                            <img
                                              src={ImageData["most-popu.png"]}
                                              alt="DocuBay"
                                            />
                                            {
                                              this.state.cplans ? (
                                                <>
                                                  <div className="disunt discountPrice1">
                                                    <span
                                                      className="discounted_amount real-price-top "
                                                      key={i}
                                                    >
                                                      <i
                                                        className="fa fa-inr"
                                                        aria-hidden="true"
                                                      ></i>
                                                      {currency}
                                                      {PlansData.actual_price} /-
                                                    </span>
                                                  </div>
                                                  <div className="mt-27" >
                                                    <span>{currency} {this.state.cplans.map((data, i) => {
                                                      return PlansData.id == data.id ? Math.trunc(data.discounted_price) : null
                                                    })}/-
                                                    </span>
                                                  </div>
                                                </>
                                              ) : (
                                                <div className="mt-27">
                                                  <span>
                                                    {currency}
                                                    {PlansData.actual_price} /-
                                                  </span>
                                                </div>
                                              )}
                                          </div>
                                        </div>
                                        <div className="temp7-txt-body">
                                          <ul>
                                            {PlansData.benefits.slice(0, 5).map(
                                              (Benefits, key) => {
                                                return (
                                                  <li key={key}>
                                                    <img
                                                      src={
                                                        SVGIcon[
                                                        "tick-membership.svg"
                                                        ]
                                                      }
                                                    />
                                                    {Benefits}
                                                  </li>
                                                );
                                              }
                                            )}
                                          </ul>
                                          <div className="temp7-txt-btn">
                                            <div className="temp7-txt-Benefits">
                                              <img
                                                src={PlansData.promotion_image}
                                                width="100%;"
                                                alt="DocuBay"
                                              />
                                            </div>
                                            <button
                                              type="submit"
                                              id="sendEnquiryBtn"
                                              className="btn-white"
                                              onClick={() => {
                                                this.makepayment(
                                                  PlansData,
                                                  this.state.cplans[i]
                                                );
                                              }}
                                            >
                                              Buy
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              } else {
                                return (
                                  <div
                                    className="temp7-sliderItem mt20 order-2"
                                    key={PlansData.name}
                                  >
                                    <div className="temp7-item">
                                      <img
                                        src={ImageData["premium-member1.png"]}
                                        alt=""
                                        className="w-100 imgbackground"
                                      />
                                      <div className="temp7-txt">
                                        <div className="temp7-txt-Head">
                                          <div className="temp7-txt-Headleft">
                                            <div className="temp7-txt-Headleft1">
                                              <img
                                                src={this.state.silverDIcon}
                                              />
                                              <span>
                                                {" "}
                                                {PlansData.title.head}{" "}
                                              </span>
                                              {PlansData.title.title}
                                            </div>
                                            <p>
                                              {PlansData.in_month_validity}{" "}
                                              Months access
                                            </p>
                                          </div>
                                          <div className="temp7-txt-Headright strike">
                                            {
                                              this.state.cplans ? (
                                                <>
                                                  <div className="disunt discountPrice2">
                                                    <span
                                                      className="discounted_amount real-price-top "
                                                      key={i}
                                                    >
                                                      <i
                                                        className="fa fa-inr"
                                                        aria-hidden="true"
                                                      ></i>
                                                      {currency}
                                                      {PlansData.actual_price} /-
                                                    </span>
                                                  </div>
                                                  <div className="mt-27" >
                                                    <span>{currency} {this.state.cplans.map((data, i) => {
                                                      return PlansData.id == data.id ? Math.trunc(data.discounted_price) : null
                                                    })}/-
                                                    </span>
                                                  </div>
                                                </>
                                              ) : (
                                                <div className=" mt-27">
                                                  <span>
                                                    {currency}
                                                    {PlansData.actual_price} /-
                                                  </span>
                                                </div>
                                              )}
                                            <div className="mt-gyay"></div>
                                          </div>
                                        </div>
                                        <div className="temp7-txt-body">
                                          <ul>
                                            {PlansData.benefits.map(
                                              (Benefits, key) => {
                                                return (
                                                  <li key={key}>
                                                    <img
                                                      src={
                                                        SVGIcon[
                                                        "tick-membership.svg"
                                                        ]
                                                      }
                                                    />
                                                    {Benefits}
                                                  </li>
                                                );
                                              }
                                            )}
                                          </ul>
                                          <div className="imgspace" />
                                          <div className="temp7-txt-btn mt-111">
                                            <button
                                              type="submit"
                                              id="sendEnquiryBtn"
                                              className="btn-white"
                                              onClick={() => {
                                                this.makepayment(
                                                  PlansData,
                                                  this.state.cplans[i]
                                                );
                                              }}
                                            >
                                              Buy
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            }
                          )}
                        </Slider>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section>
                <div className="temp8">
                  {this.state.country == "IN" ?
                    <>
                      <div className="formField mb-24">
                        <div className="temp8-promocode">Have a promo code ?</div>
                        {this.state.disableButton == false ? (
                          <a
                            onClick={() => {
                              this.applyCouponsaction();
                            }}
                            className="temp8-modal-toggle"
                          >
                            <span className="temp8-Apply">APPLY</span>
                          </a>
                        ) : null}
                        <input
                          type="text"
                          name="couponcode"
                          placeholder="Enter promo code"
                          className="temp8-promoinput"
                          value={this.state.value}
                          onChange={(e) => {
                            this.handleChange(e);
                          }}
                        />
                        {this.state.couponcodeerr ? (
                          <div className="error">
                            <img src={SVGIcon["error.svg"]} alt="DocuBay" />
                            <p>{this.state.couponcodeerr} </p>
                          </div>
                        ) : null}

                        {this.state.Resapplycouponmsg ? (
                          <div className="valid-msg">
                            <img src={SVGIcon["tick.svg"]} alt="DocuBay" />
                            <p>Promocode Applied. </p>
                          </div>
                        ) : null}
                      </div>
                    </>
                    : null}

                  <div className="formField">
                    <Link
                      to="/select-topics"
                      type="submit"
                      id="sendEnquiryBtn"
                      className="btn-black btn-gray white"
                    >
                      Skip to watch FREE documentaries
                    </Link>
                  </div>
                </div>
              </section>
            </main>
            <div
              style={{ display: this.state.showModal ? "flex" : "none" }}
              className="awesomepopup"
              id="thankq"
            >
              <div className="temp8-modal-body">
                <button
                  className="temp8-modal-close temp8-modal-toggle"
                  onClick={() => {
                    this.Closemodal();
                  }}
                >
                  <img src={SVGIcon["promocode-close.svg"]} />
                </button>
                <img src={ImageData["promocode.png"]} alt="DocuBay" />
                <div className="temp8-awesome">
                  <h5>Awesome!</h5>
                  <p>‘TRYNEW’ applied</p>
                  <h4>
                    <span>You saved</span> ₹100 /-
                  </h4>
                  <h6>with this Promocode</h6>
                </div>
              </div>
            </div>

            {/* desktop section */}
            {this.state.subscription_success ? (
              <div className="notification-box">
                <div
                  className="passChangepopup"
                  id="passChange"
                  style={{ display: "flex" }}
                >
                  <div className="temp31-modal-body popup-animation temp31-modal-body-desk temp31-modal-body-mobile">
                    <button className="temp31-modal-close temp31-modal-toggle">
                      <img
                        src={SVGIcon["promocode-close.svg"]}
                        alt="DocuBay"
                        onClick={() => {
                          this.props.navigate("/manage-membership");
                          this.setState({ subscription_success: false });
                        }}
                      />
                    </button>
                    <img
                      src={ImageData["bg-100-promocode.png"]}
                      alt="DocuBay"
                      className="imgPass imgcode-desk imgcode-mobile"
                    />
                    <div className="temp31-awesome temp31-awesome-desk temp31-awesome-mobile">
                      <h5>Coupon Redeemed Successfully</h5>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            <main className="dD-block">
              {this.state.country == "IN" ?
                localStorage.getItem("utmTrack") ?
                  (this.state.popHolder ?
                    <>
                      <div className="logOutpopup" id="logOut">
                        <div className="temp52-modal-body-img" style={{ background: "none" }}>
                          <img
                            src={ImageData["close-grey.png"]}
                            alt="closeImg"
                            style={{ top: "28px", right: "24px" }}
                            className="close-modal-icon1"
                            onClick={() => {
                              this.cancel();
                            }}
                          />
                          {/* <input type="text" value="WM33" id="myInput" hidden></input> */}
                          <img
                            src={"https://dbcms.docubay.com/media-upload/1711464660-popup-image-550x325.jpg"}
                            alt="Discount"
                            style={{ borderRadius: "12px", cursor: 'pointer' }}
                            onClick={() => { this.copyContent() }}
                          />
                          <ToastContainer />
                        </div>
                      </div>
                    </>
                    : null
                  )
                  : null
                : null}

              <header className="pb-m">
                <div className="mainNav pmenu policy-left" style={{ zIndex: "1" }}>
                  <Link to="/">
                    <div className="docubayLogo">
                      <img
                        src={ImageData["docu-bay-white.png"]}
                        alt="DocuBay Logo"
                      />
                    </div>
                  </Link>
                </div>
                <div className="explore-plan-desk">Become A Member</div>
              </header>
              <div className="temp4 temp4-desk2 dD-block">
                <hr className="border-red" />
                <hr />
                <div className="temp4-InnerRound50">
                  <div className="temp4-InnerRound1">
                    <div className="temp4-InnerRound2" />
                  </div>
                </div>
                <div className="temp4-InnerRound51">
                  <div className="temp4-InnerRound1">
                    <div className="temp4-InnerRound2" />
                  </div>
                </div>
                <div className="temp4-InnerRound52">
                  <div className="temp4-InnerRound3" />
                </div>
              </div>
              <section className="mb-32">
                <div className="temp7">
                  <div className="temp7-inner">
                    <div className="temp7-head">
                      {/* <img
                        src={ImageData["bannerImageMembership.jpg"]}
                        alt="DocuBay"
                      /> */}
                      {this.state.country == "IN" ?
                        <img
                          src={"https://dbcms.docubay.com/media-upload/1711960746-membership-bannernew.jpg"}
                          alt="DocuBay"
                        /> :
                        <img
                          src={ImageData["bannerImageMembership.jpg"]}
                          alt="DocuBay"
                        />
                      }
                      <h5>Choose a plan</h5>
                    </div>
                    <div className="temp7-sliderArea">
                      <div className="temp7-slider">
                        {this.state.SubscriptionPlansData.data.plans.map(
                          (PlansData, i) => {
                            var currencyData = CurrencyData();
                            var Pricecurr = PlansData.currency;
                            var currency = currencyData[Pricecurr];
                            if (Pricecurr == "U") {
                            }
                            if (PlansData.name == "Yearly") {
                              return (
                                <div
                                  className="temp7-sliderItem order-1"
                                  key={PlansData.name}
                                >
                                  <div className="temp7-item">
                                    <img
                                      src={ImageData["onetribe-member1.png"]}
                                      alt=""
                                      className="w-100 imgbackground"
                                      Unlimited
                                      documentaries
                                    />
                                    <div className="temp7-txt">
                                      <div className="temp7-txt-Head">
                                        <div className="temp7-txt-Headleft">
                                          <div className="temp7-txt-Headleft1 white2">
                                            <img src={this.state.silverDIcon} />
                                            <span>
                                              {" "}
                                              {PlansData.title.head}{" "}
                                            </span>
                                            {PlansData.title.title}
                                          </div>
                                          <p className="white">
                                            {PlansData.in_month_validity} Months
                                            access
                                          </p>
                                        </div>
                                        <div className="temp7-txt-Headright white2">
                                          <img
                                            src={ImageData["most-popu.png"]}
                                            alt="DocuBay"
                                          />
                                          {
                                            this.state.cplans ? (
                                              <>
                                                <div className="disunt discountPrice1 yearly_hidden_plan">
                                                  <span
                                                    className="discounted_amount real-price-top "
                                                    key={i}
                                                  >
                                                    <i
                                                      className="fa fa-inr"
                                                      aria-hidden="true"
                                                    ></i>
                                                    {currency}
                                                    {PlansData.actual_price} /-
                                                  </span>
                                                </div>
                                                <div className=" mt-27" >
                                                  <span>{currency} {this.state.cplans.map((data, i) => {
                                                    return PlansData.id == data.id ? Math.trunc(data.discounted_price) : null
                                                  })}/-
                                                  </span>
                                                </div>
                                              </>
                                            ) : (
                                              <div className="mt-27">
                                                <span>
                                                  {currency}
                                                  {PlansData.actual_price} /-
                                                </span>
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                      <div className="temp7-txt-body">
                                        <ul>
                                          {PlansData.benefits.slice(0, 5).map(
                                            (Benefits, key) => {
                                              return (
                                                <li key={key}>
                                                  <img
                                                    src={
                                                      SVGIcon[
                                                      "tick-membership.svg"
                                                      ]
                                                    }
                                                  />
                                                  {Benefits}
                                                </li>
                                              );
                                            }
                                          )}
                                        </ul>
                                        <div className="temp7-txt-btn">
                                          <div className="temp7-txt-Benefits">
                                            <img
                                              src={PlansData.promotion_image}
                                              alt="DocuBay"
                                            />
                                          </div>
                                          <button
                                            type="submit"
                                            id="sendEnquiryBtn"
                                            className="btn-white"
                                            onClick={() => {
                                              this.makepayment(
                                                PlansData,
                                                this.state.cplans[i]
                                              );
                                            }}
                                          >
                                            Buy
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            } else if (PlansData.name == "Monthly") {
                              return (
                                <div
                                  div
                                  className="temp7-sliderItem mt20 order-2"
                                  key={PlansData.name}
                                >
                                  <div className="temp7-item">
                                    <img
                                      src="img/premium-member1.png"
                                      alt=""
                                      className="w-100"
                                    />
                                    <div className="temp7-txt">
                                      <div className="temp7-txt-Head">
                                        <div className="temp7-txt-Headleft">
                                          <div className="temp7-txt-Headleft1">
                                            <img src={this.state.silverDIcon} />
                                            <span>
                                              {" "}
                                              {PlansData.title.head}{" "}
                                            </span>
                                            {PlansData.title.title}
                                          </div>
                                          <p>
                                            {PlansData.in_month_validity} Months
                                            Access
                                          </p>
                                        </div>
                                        <div className="temp7-txt-Headright strike">
                                          {
                                            this.state.cplans ? (
                                              <>
                                                <div className="disunt discountPrice2 monthly_hidden_plan">
                                                  <span
                                                    className="discounted_amount real-price-top"
                                                    key={i}
                                                  >
                                                    <i
                                                      className="fa fa-inr"
                                                      aria-hidden="true"
                                                    ></i>
                                                    {currency}
                                                    {PlansData.actual_price} /-
                                                  </span>
                                                </div>
                                                <div className=" mt-27" >
                                                  <span>{currency} {this.state.cplans.map((data, i) => {
                                                    return PlansData.id == data.id ? Math.trunc(data.discounted_price) : null
                                                  })}/-
                                                  </span>
                                                </div>
                                              </>
                                            ) : (
                                              <div className=" mt-27">
                                                <span>
                                                  {currency}
                                                  {PlansData.actual_price} /-
                                                </span>
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                      <div className="temp7-txt-body">
                                        <ul>
                                          {PlansData.benefits.map(
                                            (Benefits, key) => {
                                              return (
                                                <li key={key}>
                                                  <img
                                                    src={
                                                      SVGIcon[
                                                      "tick-membership.svg"
                                                      ]
                                                    }
                                                  />
                                                  {Benefits}
                                                </li>
                                              );
                                            }
                                          )}
                                        </ul>
                                        <div className="temp7-txt-btn mt-111">
                                          <button
                                            type="submit"
                                            id="sendEnquiryBtn"
                                            className="btn-white"
                                            onClick={() => {
                                              this.makepayment(
                                                PlansData,
                                                this.state.cplans[i]
                                              );
                                            }}
                                          >
                                            Buy
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            } else if (PlansData.name == "Quarterly") {
                              return (
                                <div
                                  className="temp7-sliderItem mt20"
                                  key={PlansData.name}
                                >
                                  <div className="temp7-item">
                                    <img
                                      src="img/premium-member1.png"
                                      alt=""
                                      className="w-100"
                                    />
                                    <div className="temp7-txt">
                                      <div className="temp7-txt-Head">
                                        <div className="temp7-txt-Headleft">
                                          <div className="temp7-txt-Headleft1">
                                            <img src={this.state.silverDIcon} />
                                            <span>
                                              {" "}
                                              {PlansData.title.head}{" "}
                                            </span>
                                            {PlansData.title.title}
                                          </div>
                                          <p>
                                            {PlansData.in_month_validity} Months
                                            Access
                                          </p>
                                        </div>
                                        <div className="temp7-txt-Headright strike">
                                          {
                                            this.state.cplans ? (
                                              <>
                                                <div className="disunt discountPrice2 quarterly_hidden_plan">
                                                  <span
                                                    className="discounted_amount real-price-top "
                                                    key={i}
                                                  >
                                                    <i
                                                      className="fa fa-inr"
                                                      aria-hidden="true"
                                                    ></i>
                                                    {currency}
                                                    {PlansData.actual_price} /-
                                                  </span>
                                                </div>
                                                <div className=" mt-27" >
                                                  <span>{currency} {this.state.cplans.map((data, i) => {
                                                    return PlansData.id == data.id ? Math.trunc(data.discounted_price) : null
                                                  })}/-
                                                  </span>
                                                </div>

                                              </>
                                            ) : (
                                              <div className=" mt-27">
                                                <span>
                                                  {currency}
                                                  {PlansData.actual_price} /-
                                                </span>
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                      <div className="temp7-txt-body">
                                        <ul>
                                          {PlansData.benefits.map(
                                            (Benefits, key) => {
                                              return (
                                                <li key={key}>
                                                  <img
                                                    src={
                                                      SVGIcon[
                                                      "tick-membership.svg"
                                                      ]
                                                    }
                                                  />
                                                  {Benefits}
                                                </li>
                                              );
                                            }
                                          )}
                                        </ul>
                                        <div className="temp7-txt-btn mt-111">
                                          <button
                                            type="submit"
                                            id="sendEnquiryBtn"
                                            className="btn-white"
                                            onClick={() => {
                                              this.makepayment(
                                                PlansData,
                                                this.state.cplans[i]
                                              );
                                            }}
                                          >
                                            Buy
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          }
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section>
                <div className="temp8">
                  {this.state.country == "IN" ?
                    <>
                      <div className="formField mb-24">
                        <div className="temp8-promocode">Have a promo code ?</div>
                        {this.state.disableButton == false ? (
                          <a
                            onClick={() => {
                              this.applyCouponsaction();
                            }}
                            className="temp8-modal-toggle"
                          >
                            <span className="temp8-Apply">APPLY</span>
                          </a>
                        ) : null}
                        <input
                          type="text"
                          name="couponcode"
                          placeholder="Enter promo code"
                          className="temp8-promoinput"
                          value={this.state.value}
                          onChange={(e) => {
                            this.handleChange(e);
                          }}
                        />
                        {this.state.couponcodeerr ? (
                          <div className="error">
                            <img src={SVGIcon["error.svg"]} alt="DocuBay" />
                            <p>{this.state.couponcodeerr} </p>
                          </div>
                        ) : null}
                        {this.state.Resapplycouponmsg ? (
                          <div className="valid-msg">
                            <img src={SVGIcon["tick.svg"]} alt="DocuBay" />
                            <p>Promocode Applied. </p>
                          </div>
                        ) : null}
                      </div>
                    </>
                    : null}
                  <div className="formField">
                    <Link
                      to="/select-topics"
                      type="submit"
                      id="sendEnquiryBtn"
                      className="btn-black btn-gray white"
                    >
                      Skip to watch FREE documentaries
                    </Link>
                  </div>
                </div>
              </section>
            </main>
            {/* {this.props.skipwatch == "true" ? (<Mobilemenu active="5" />) : null} */}
          </motion.div>
        </>
      );
    }
  }
}

export default withRouter(ExplorePlan);
